import { render, staticRenderFns } from "./TwoInputStep.vue?vue&type=template&id=1842c550&scoped=true&"
import script from "./TwoInputStep.vue?vue&type=script&lang=js&"
export * from "./TwoInputStep.vue?vue&type=script&lang=js&"
import style0 from "./TwoInputStep.vue?vue&type=style&index=0&id=1842c550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1842c550",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContactStepHeader: require('/opt/build/repo/components/contact/StepHeader.vue').default})
